import { render, staticRenderFns } from "./BackDatingCoverage.vue?vue&type=template&id=4cfb067c"
import script from "./BackDatingCoverage.vue?vue&type=script&lang=ts"
export * from "./BackDatingCoverage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports